module.exports = __webpack_public_path__ + "img/RabihElMdawar-v1.7ac1b677.png";